import { render, staticRenderFns } from "./modifyLogistics.vue?vue&type=template&id=e06843d6&scoped=true&"
import script from "./modifyLogistics.vue?vue&type=script&lang=js&"
export * from "./modifyLogistics.vue?vue&type=script&lang=js&"
import style0 from "./modifyLogistics.vue?vue&type=style&index=0&id=e06843d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06843d6",
  null
  
)

component.options.__file = "modifyLogistics.vue"
export default component.exports